module.exports = __webpack_public_path__ + "static/media/22import-49.edc642fd.xlsx";